import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Container, Tab, Tabs } from "react-bootstrap";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { formatDate } from "../../../commons/FormatValue";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../commons/ServiceRequest";
import Table from "../../../components/Table";
import SearchFilter from "../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../components/ButtonOptionSubmenu";
import CustContractItemsService from "../../../services/custcontractitem.service";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import CardDisplayComponent from "../../../components/CardDisplayComponent";

export default function DeleteBindingPMServiceContract() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);
  const defaultSearch = [
    {
      name: "Contract_No",
      label: "เลขที่สัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest:
            CustContractItemsService.getAllCustContractItems(query),
          callback: ({ items }) => setData(items)
        })
    },
    {
      name: "Contract_Type",
      label: "ประเภทสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "PM_Per_Year",
      label: "จำนวน PM/ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: null,
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Change_Pm_Per_Year",
      label: "เปลี่ยนจำนวน PM/ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: null,
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "Reason_Change_Pm_Per_Year",
      label: "สาเหตุที่เปลี่ยนจำนวน PM/ปี",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "CustContract.Customer.Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" }
    },
    {
      name: "CustContract.Customer.Cus_NumBranch",
      label: "เลขที่สาขา",
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" },
      size: "1_5"
    },
    {
      name: "CustContract.Customer.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      type: "text",
      disabled: true,
      findValue: { value: "Contract_No" },
      size: "4_5"
    }
  ];
  const [searchInput, setSearchInput] = useState(defaultSearch);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "เลขที่โครงการ",
      selector: (row) => row.CustContract?.Project_No,
      sortable: true,
      minWidth: "180px"
    },
    {
      name: "เลขที่สัญญา",
      selector: (row) => row.Contract_No,
      sortable: true,
      minWidth: "180px"
    },
    {
      name: "วันที่เริ่มต้นสัญญา",
      selector: (row) => row.CustContract?.Contract_Start_Date,
      format: (row) => formatDate(row.CustContract?.Contract_Start_Date),
      minWidth: "180px"
    },
    {
      name: "วันที่สิ้นสุดสัญญา",
      selector: (row) => row.CustContract?.Contract_End_Date,
      format: (row) => formatDate(row.CustContract?.Contract_End_Date),
      minWidth: "180px"
    },
    {
      name: "รหัสสินค้า",
      selector: (row) => row.Item?.Item_Code,
      minWidth: "200px"
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row.Item?.Item_Name_TH,
      minWidth: "350px"
    },
    {
      name: "ประเภทบริการ",
      selector: (row) => row.DownTime?.DT_Name,
      minWidth: "180px"
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          deleteButton
          onDeleteCallback={(event, { Id, Contract_No }) =>
            deleteServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: CustContractItemsService.deleteCustContractItems(
                Id,
                true
              ),
              refreshRequest: CustContractItemsService.getAllCustContractItems(
                `?keyword=${Contract_No}`
              ),
              callback: ({ items }) => {
                setData(items || []);
                setSearchInput(
                  defaultSearch.map((item) =>
                    item.name === "Contract_No"
                      ? { ...item, value: Contract_No }
                      : item
                  )
                );
              }
            })
          }
        />
      ),
      right: true,
      width: "180px"
    }
  ];

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        binding: "ลบสินค้าออกจากสัญญา",
        assign: "สร้างหมายเลขเครื่องประจำสาขา",
        determine: "กำหนดอายุอุปกรณ์/อะไหล่"
      }
    });
  };

  useEffect(() => {
    handleChangeTab(state?.name || "binding");
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest:
        CustContractItemsService.getAllCustContractItems("?limit=1000"),
      callback: ({ items }) => setData(items)
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta
          name="description"
          content="Edit Binding a contract with the product Page"
        />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="branch" title="ผูกสัญญากับสาขา"></Tab>
          <Tab eventKey="binding" title="ผูกสัญญากับสินค้า">
            <CardDisplayComponent
              header={{
                title: {
                  className: "text-center",
                  text: "ลบข้อมูลสินค้าออกจากสัญญา"
                }
              }}
              body={{
                element: (
                  <SearchFilter
                    data={data}
                    inputField={searchInput}
                    fieldClassName={{
                      inputRow: "justify-content-start align-items-center",
                      actionButton: "w-auto py-2"
                    }}
                    searchCallback={(search) => setSearchValue(search)}
                  />
                )
              }}
            />

            <CardDisplayComponent
              header={{ title: { text: "ลบสินค้าออกจากสัญญา" } }}
              body={{
                element: (
                  <Table
                    data={data}
                    column={columns}
                    searchFilter={searchValue}
                  />
                )
              }}
              footer={{
                className: "text-end",
                element: (
                  <Button
                    variant="outline-success"
                    className="px-5 py-2 text-dark border-secondary rounded-pill"
                    onClick={() => navigate(-1)}
                  >
                    ยกเลิก
                  </Button>
                )
              }}
            />
          </Tab>
          <Tab eventKey="machine" title="ผูกสัญญากับสาขา"></Tab>
          <Tab eventKey="determine" title="กำหนดอายุอุปกรณ์/อะไหล่"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
